import { Header as DsfrHeader, HeaderQuickAccessItem } from "@codegouvfr/react-dsfr/Header"
import { useMemo } from "react"
import type { IUserRecruteurPublic } from "shared"
import { getDepotCtaHref } from "@/services/get-depot-cta-href"
import { PAGES } from "@/utils/routes.utils"
import { AuthWatcher } from "./AuthWatcher"
import { DsfrHeaderNavigation, DsfrHeaderProps } from "./Header"
import { headerId, type ZoneName } from "./zone-ids"

export function PublicHeader({ zone, user, hideConnectionButton = false }: { zone: ZoneName; user?: IUserRecruteurPublic; hideConnectionButton?: boolean }) {
  const props = useMemo(() => {
    const extraItems = [
      <HeaderQuickAccessItem
        key="publier-offre"
        quickAccessItem={{
          iconId: "fr-icon-global-line",
          text: "Publier une offre d'emploi",
          linkProps: {
            href: getDepotCtaHref(user ?? null, "ENTREPRISE"),
          },
        }}
      />,
    ]

    if (user) {
      extraItems.push(
        <HeaderQuickAccessItem
          key="mon_compte"
          quickAccessItem={{
            iconId: "fr-icon-account-line",
            text: `${user.first_name} ${user.last_name.toLocaleUpperCase()}`,
            linkProps: {
              href: PAGES.dynamic.backHome({ userType: user.type }).getPath(),
            },
          }}
        />
      )
    }
    if (!user && !hideConnectionButton) {
      extraItems.push(
        <HeaderQuickAccessItem
          key="connexion"
          quickAccessItem={{
            iconId: "fr-icon-lock-line",
            text: "Connexion",
            linkProps: {
              href: PAGES.static.authentification.getPath(),
            },
          }}
        />
      )
    }

    return {
      ...DsfrHeaderProps,
      id: headerId(zone),
      quickAccessItems: [...(DsfrHeaderProps.quickAccessItems ?? []), ...extraItems],
    }
  }, [zone, user, hideConnectionButton])

  return (
    <>
      <AuthWatcher user={user} />
      <DsfrHeader {...props} navigation={<DsfrHeaderNavigation />} />
    </>
  )
}

export const PublicHeaderStatic = ({ zone }: { zone: ZoneName }) => {
  return <DsfrHeader {...DsfrHeaderProps} id={headerId(zone)} navigation={<DsfrHeaderNavigation />} />
}
